module.exports = __webpack_public_path__ + "static/weltew-sm-8a14dcc3f50d024a2658d62cb5e199e2.jpg";